import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

import { useDebounce } from '../../shared/hooks';
import { useField } from '@unform/core';
import { TransportadoraService } from '../services/api/cadastros/TransportadoraService';

type TAutoCompleteOption = {
  idtransportadora: string;
  label: string;
}

interface IAutoCompleteTransportadoraProps {
  isExternalLoading?: boolean; 
  uuidtransportadora?: (novoTextoselect: string | undefined) => void;
}

export const AutoCompleteTransportadora: React.FC<IAutoCompleteTransportadoraProps> = ({ isExternalLoading = false, uuidtransportadora }) => {

  const { fieldName, registerField, defaultValue, error, clearError } = useField('idtransportadora');


  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setIsLoading(true);
  
    debounce(() => {
      TransportadoraService.getAllList(busca, selectedId)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            // alert(result.message);
          } else {
            setOpcoes(result.data.map(transportadora => ({ idtransportadora: transportadora.idtransportadora, label: transportadora.nome })));
          }
        });
    });
  }, [busca, selectedId]);
 
  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idtransportadora === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);
  
  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'

      disablePortal

      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.idtransportadora); uuidtransportadora?.(newValue?.idtransportadora); setBusca(''); clearError(); }}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Transportadora"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};